module.exports = __webpack_public_path__ + "static/media/fmla-summary.d4af56ae.png";